var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"text-left p-5"},[_c('router-link',{staticClass:"h1 text-white logo p-2",attrs:{"to":"/"}},[_vm._v("Aformac TV")])],1)]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }